(function quickExitInit() {
    const quickExit = document.querySelectorAll('.opg-quick-exit');

    if (
        quickExit.length > 0 &&
        document.querySelectorAll('.opg-quick-exit__button').length > 0
    ) {
        const quickExitFunc = function handleQuickExit(site) {
            // then redirect to a non-sensitive site
            window.open(site, '_blank');
            window.location.replace(site);

            // remove as much info from URL as possible
            if (window.history) {
                try {
                    window.history.replaceState({}, '', '/');
                } catch (e) {
                    // Silent fail for history replacement
                }
            }

            // disable default event handling
            return false;
        };
        const initializeQuickExit = function initializeQuickExit() {
            const button = document.querySelector('.opg-quick-exit__button');
            const escapeSite = 'https://www.google.com.au/';
            const hotkey = 27;

            // add click handler
            button.onclick = function handleClick() {
                return quickExitFunc(escapeSite);
            };

            // load a plugin only on IE browser to support position:sticky
            if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
                // stickyfill.add(document.querySelector('.opg-quick-exit'));
            }

            // add hotkey trigger
            document.addEventListener('keydown', function handleKeydown(e) {
                if (e.keyCode === hotkey) {
                    quickExitFunc(escapeSite);

                    if (e) {
                        // stop escape from cancelling redirect
                        e.preventDefault();

                        // early IEs don't have preventDefault
                        e.returnValue = false;
                    }

                    return false;
                }
                return false;
            });
        };

        initializeQuickExit();
    }
})();
